import { render, staticRenderFns } from "./AppPrivacy.vue?vue&type=template&id=dd86cca6&"
import script from "./AppPrivacy.vue?vue&type=script&lang=js&"
export * from "./AppPrivacy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports